import React, { useState } from "react";
import { ScanLine, Camera, Loader2 } from "lucide-react";

/* 扫码枪（USB 键盘模式）/ 手动输入：回车即识别；右侧打开摄像头 */
export const ScanInput = ({ onCode, zh, busy, onCamera, inputRef }) => {
  const [v, setV] = useState("");
  const submit = () => { const t = v.trim(); if (!t) return; onCode(t, "scanner"); setV(""); };
  return (
    <div className="flex items-stretch gap-2" data-testid="wms-scan-bar">
      <div className="flex-1 flex items-center gap-2 rounded-xl border-2 border-red-300 bg-white px-3 focus-within:border-red-500 focus-within:ring-4 focus-within:ring-red-100 transition-shadow">
        <ScanLine className="h-5 w-5 text-red-500 shrink-0" />
        <input ref={inputRef} data-testid="wms-scan-input" value={v} onChange={(e) => setV(e.target.value)} autoFocus autoComplete="off" spellCheck={false}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); submit(); } }}
          placeholder={zh ? "扫码枪对准二维码扫描（自动回车），或手动输入编码后回车" : "Scan with a USB scanner or type a code and press Enter"}
          className="flex-1 h-12 text-sm outline-none bg-transparent" />
        {busy && <Loader2 className="h-4 w-4 animate-spin text-slate-400" />}
        <button type="button" data-testid="wms-scan-submit" onClick={submit} className="text-xs font-semibold text-red-600 hover:text-red-800">{zh ? "确认" : "Enter"}</button>
      </div>
      <button type="button" data-testid="wms-camera-open" onClick={onCamera} className="rounded-xl bg-slate-900 hover:bg-slate-800 text-white px-4 inline-flex items-center gap-1.5 text-sm font-semibold transition-colors">
        <Camera className="h-4 w-4" />{zh ? "摄像头" : "Camera"}
      </button>
    </div>
  );
};
